/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_PATH } from "../config";

const getDynamicPages = () => {
  return axios.get(`${API_PATH}v1/dynamic_pages?type=3`);
};

const getDynamicPage = (id) => {
  return axios.get(`${API_PATH}v1/dynamic_pages/${id}?type=3`);
};


export default {
  getDynamicPages,
  getDynamicPage
};
